import type { FaireProductEntity } from "../../entity_types/product";

export const p_nw3mnxsvft: FaireProductEntity = {
  token: "p_nw3mnxsvft",
  type: "product",
  name: "Spring Chick Kitchen Towel",
  brandToken: "b_4knjkc8j",
  brandName: "Primitives by Kathy",
  imageUrl: "https://cdn.faire.com/fastly/e36b1613a8ad97efc3568301f5713526e58b990490ca8fbcff48a0eb83625d23.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd6cb0e9dbe85149176fd80604f8ea80121f20b6b91f1ad0ec7ee99db80c6c73.jpeg",
    "https://cdn.faire.com/fastly/fb4f9ccee66ad478a83acddbd07f542251beb327248417ba451b68f761ee7bac.jpeg",
    "https://cdn.faire.com/fastly/92e7906118587d420261ceb0cc14377309fbc4856104b9cd1e146a3663f9a227.jpeg",
    "https://cdn.faire.com/fastly/38d2a71d3d40c3700792dfc9bfa84d65afcf57d3faed5bf9a8459dd950303668.jpeg",
    "https://cdn.faire.com/fastly/9cca8ec69723521572fa583f7e72a2612e2101dec40eaaed34a6f2e030f99f45.jpeg",
    "https://cdn.faire.com/fastly/48552f97d08dd30ee3478ba03a017a139c5650c254457967a0f4aea98dbb8cc0.jpeg"
  ],
  priceDollars: 8,
  description: "A microfiber kitchen towel from our Easter & Spring Collection featuring an all-over design displaying a charming scene of a chicken and chicks in a field of spring flowers. The spring chick design is replicated from original artwork painted onto burlap canvas, giving the art a unique depth and texture. Double-sided towel displays a coordinating stripe pattern on the back that offers multiple display options with a cotton tape hanger in the corner for hanging. Our Spring Chick kitchen towel is conveniently machine washable for easy cleaning. Spring farm towel is packaged on a cardboard hanger with hole to easily display on store rack. A farm-themed kitchen accessory that easily adds seasonal style to any kitchen.",
  tags: [],
  msrpDollars: 15.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:04:11.308Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
